import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  autoBet, cashOutBet, getBetHistory, getLiveStats, getPreviousRoundState, getTopBets, mineCheckFairness, openTile, placeBet
} from 'network/services/mine.service'
import { setRoundResult } from '../redux/slices/mineGame.slice'
import { BET_RESULT } from 'utils/constants/index'
import { openErrorToaster } from 'utils/common-services/toaster.service'

export const getMineGamePreviousRoundState = createAsyncThunk(
  'mineGame/get-unfinished-bet-state', async (_, thunkApi) => {
    try {
      const res = await getPreviousRoundState()
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0]?.description)
    }
  }
)

export const getMyBetsMineGame = createAsyncThunk(
  'mineGame/my-bets', async (data, thunkApi) => {
    try {
      const res = await getBetHistory(data)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0]?.description)
    }
  }
)

export const mineGamePlacedBet = createAsyncThunk(
  'mineGame/place-bet', async ({ payload }, thunkApi) => {
    try {
      const res = await placeBet(payload)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0]?.description)
    }
  }
)

export const mineGameAutoBet = createAsyncThunk(
  'mineGame/place-auto-bet', async ({ payload, normalTileAudio, mineTileAudio, mute }, thunkApi) => {
    try {
      const res = await autoBet(payload)
      setTimeout(() => {
        if (res?.bet?.result === BET_RESULT.LOST) {
          thunkApi.dispatch(setRoundResult({ isLastWin: false, isLastLoss: true }))
        } else {
          thunkApi.dispatch(setRoundResult({ isLastWin: true, isLastLoss: false }))
        }
      }, 2000)
      if (!mute) {
        res?.bet?.result === BET_RESULT.WON ? normalTileAudio?.play() : mineTileAudio?.play()
      }
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0]?.description)
    }
  }
)

export const mineGameOpenTile = createAsyncThunk(
  'mineGame/open-tile', async (payload, thunkApi) => {
    try {
      const { normalTileAudio, mineTileAudio, tile, mute } = payload
      const { minesVolume } = thunkApi?.getState()?.mineGame
      const res = await openTile({ tile })

      if (res?.mineTile) {
        setTimeout(() => {
          thunkApi.dispatch(setRoundResult({ isLastWin: false, isLastLoss: true }))
        }, 2000)
        if (!mute) {
          mineTileAudio.volume = minesVolume
          mineTileAudio?.play()
        }
      } else {
        if (!mute) {
          normalTileAudio.volume = minesVolume
          normalTileAudio?.play()
        }
      }
      res.tile = payload.tile
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0]?.description)
    }
  }
)

export const mineGameCashOut = createAsyncThunk(
  'mineGame/cashout-bet', async (_, thunkApi) => {
    try {
      const res = await cashOutBet()
      setTimeout(() => {
        thunkApi.dispatch(setRoundResult({ isLastWin: true, isLastLoss: false }))
      }, 2000)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0]?.description)
    }
  }
)

// not used
export const minGameTopBets = createAsyncThunk(
  'mineGame/top-bets', async (_, thunkApi) => {
    try {
      const res = await getTopBets()
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0]?.description)
    }
  }
)

// not used
export const verifyProvableFairMine = createAsyncThunk('crash-game/check-provable-fair', async (payload, thunkApi) => {
  try {
    const res = await verifyProvableFairMine(payload)
    return res
  } catch (error) {
    return thunkApi.rejectWithValue(error[0].description)
  }
})

// not used
export const getMineGameLiveStats = createAsyncThunk(
  'mineGame/get-mine-game-live-stats', async (_, thunkApi) => {
    try {
      const res = await getLiveStats()
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0]?.description)
    }
  }
)

export const checkFairnessMineGame = createAsyncThunk('mine-game/check-fairness', async (payload, thunkApi) => {
  try {
    const res = await mineCheckFairness(payload)
    return res
  } catch (error) {
    openErrorToaster({ message: error[0].description })
    return thunkApi.rejectWithValue(error[0].description)
  }
})
